module.exports = __webpack_public_path__ + "static/media/pro-detail-img3.e7cf9363.jpg";